<template>
    <div class="header clearfix">
        <router-link tag="li" to="/user" class="header-avatar" v-if="hasAvatar">
          <img src="../assets/images/icons/logo_avatar.png" alt="">
        </router-link>
        <div class="header-return" @click="goBack" v-if="!hasAvatar && !leftNoContent && historyLength > 1">
          <div class="header-return-btn">
            返回
          </div>
        </div>
        <div class="header-name inaline">
          {{userRealname}}
        </div>
        <!-- 测试按钮 -->
        <!-- <span style="display: inline-block; width: 50px; height: 30px; color: #fff" v-tap="{methods: testBtn}">测试</span> -->
        <div class="header-qr">
          扫一扫
          <i class="icon-qr" @click="scanDebounceHandle"></i>
        </div>
    </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { mapState } from 'vuex'
import { toast } from '@/utils/toast'
import { getWxConfig } from '@/api/wxConfig'
import { directRightUrl, checkWx, checkAli } from '@/utils/tool'
import { showPartnerInviteShareTitle } from '@/api/config'

// import shareLogo from '@/assets/images/wx_share_logo.png'
var barcode = null // uni-app 内扫码控件
function debounce (fn, delay = 300) {
    let timer = null
    return function () {
        let ctx = this
        let args = arguments
        if (timer) clearTimeout(timer)
        timer = setTimeout(function() {
            fn.apply(ctx, args)
        }, delay)
    }
}
export default {
  name: 'yi-header',
  props: ['has-avatar', 'user-realname', 'left-no-content'],
  data () {
    return {
      config: {
        debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: '', // 必填，公众号的唯一标识
        timestamp: '', // 必填，生成签名的时间戳
        nonceStr: '', // 必填，生成签名的随机串
        signature: '', // 必填，签名
        jsApiList: ['scanQRCode'], // 必填，需要使用的JS接口列表

        shareTitle: '',
        shareSubTitle: '',
      },
      scanOn: true
    }
  },
  components: {

  },
  computed: {
    ...mapState({
      userInviteCode: state => state.user.selectedConference.userInviteCode + '',
      userInviteCodeUrlCopy: state => location.origin + '/#/i/' + state.user.selectedConference.brandId + '/' + state.user.selectedConference.conferenceId + '/' + state.user.selectedConference.userInviteCode,
      brandId: state => state.user.selectedConference.brandId,
      selectedConferenceId: state => state.user.selectedConference.conferenceId,
      webView: state => state.user.webView
    }),
    historyLength: function() {
      return window.history.length
    }
  },
  created () {
    // 获取分享标题
    // this.getShareTitle();
    if (checkWx()) {
      directRightUrl(this.getConfig)
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    getShareTitle() {
      showPartnerInviteShareTitle({
        conferenceId: this.selectedConferenceId,
        userId: this.brandId
      }).then(res => {
        console.log(res);
        if (res.data.erroyCode == 200 && res.data.dto) {
          this.shareTitle = res.data.dto.partnerInviteShareMainTitle || ''
          this.shareSubTitle = res.data.dto.partnerInviteShareSubTitle || ''
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getConfig () {
      let url = window.location.href.split('#')[0]
      let that = this
      console.log(url)
      getWxConfig({url: url}).then(response => {
        console.log(response)
        let data = response.data

        let shareTitle = '2019秋冬订货会'
        // if (this.brandId === '8') {
        //   shareTitle = '『合煦服饰 & 服装综合体』·数聚时尚战略发布会'
        // } else if (this.brandId === '9') {
        //   shareTitle = '『伯喜服饰 & 服装综合体』·数聚时尚战略发布会'
        // } else if (this.brandId === '10') {
        //   shareTitle = '『高珂服饰 & 服装综合体』·数聚时尚战略发布会'
        // } else if (this.brandId === '116') {
        //   shareTitle = '『丁琳服饰 & 服装综合体』·数聚时尚战略发布会' 
        // } else {
        //   shareTitle = '『服装综合体·数聚时尚』战略发布会'
        // }
    
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.dto.appId, // 必填，公众号的唯一标识
          timestamp: data.dto.timestamp + '', // 必填，生成签名的时间戳
          nonceStr: data.dto.nonceStr, // 必填，生成签名的随机串
          signature: data.dto.signature, // 必填，签名
          jsApiList: ['scanQRCode', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'openLocation', 'getLocation'] // 必填，需要使用的JS接口列表
        })
      
        wx.ready(function (res) {
          console.log('suc =>', res)
          wx.updateAppMessageShareData({ 
            title: that.shareTitle || shareTitle, // 分享标题
            desc: that.shareSubTitle || '', // 分享描述
            link: that.userInviteCodeUrlCopy, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: location.origin + '/wx_share_logo_spring.png', // 分享图标
            success: function (res) {
              console.log('res =>', res)
            }
          })
          wx.updateTimelineShareData({ 
            title: that.shareTitle || shareTitle, // 分享标题
            link: that.userInviteCodeUrlCopy, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: location.origin + '/wx_share_logo_spring.png', // 分享图标
            success: function (res) {
              console.log('res =>', res)
              // 设置成功
            }
          })
        })
        wx.error(function (res) {
          console.log('err =>', res)
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          directRightUrl(that.getConfig())
        })
      }).catch(error => {
        console.log(error)
      })
    },
    // 扫码防抖处理
    scanDebounceHandle: debounce(function() {
      this.scanHandle(...arguments)
    }),
    // 扫码直接调用
    scanHandle () {
      console.log('scanHandle')
      if(!this.scanOn) return
      this.scanOn = false
      console.log('scanHandle')
      let that = this
      if (checkWx()) {
        console.log('scanQRCode => start')
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            console.log('scanQRCode =>', res)
            var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
            if (result.split('?')[0] !== location.origin + '/#/goodsdetail') {
              toast('温馨提示：此二维码非商品二维码')
              return false
            } else if (!result.split('?')[1]) {
              toast('温馨提示：此二维码非商品二维码')
              return false
            } else if (that.getLinkParam('itemId', result.split('?')[1]) === ''){
              toast('温馨提示：此二维码非商品二维码')
              return false
            } else if (that.getLinkParam('conference', result.split('?')[1]) === '') {
              toast('温馨提示：此二维码非商品二维码')
              return false
            } else {
              location.href = result
            }
          }
        })
      } else if (checkAli()) {
        ap.scan(function(res){
          var result = res.code;
          if (result.split('?')[0] !== location.origin + '/#/goodsdetail') {
            toast('温馨提示：此二维码非商品二维码')
            return false
          } else if (!result.split('?')[1]) {
            toast('温馨提示：此二维码非商品二维码')
            return false
          } else if (that.getLinkParam('itemId', result.split('?')[1]) === ''){
            toast('温馨提示：此二维码非商品二维码')
            return false
          } else if (that.getLinkParam('conference', result.split('?')[1]) === '') {
            toast('温馨提示：此二维码非商品二维码')
            return false
          } else {
            location.href = result
          }
        });
      } else if (this.webView == 'yjjapp') {
        // 扫码成功回调
        function onmarked(type, result) {
          var text = '未知: ';
          switch(type){
            case plus.barcode.QR:
            text = 'QR: ';
            break;
            case plus.barcode.EAN13:
            text = 'EAN13: ';
            break;
            case plus.barcode.EAN8:
            text = 'EAN8: ';
            break;
          }
          // alert( text+result );
        }
        // 创建Barcode扫码控件
        function createBarcode() {
          barcode = plus.barcode.getBarcodeById('barcode')
          if(!barcode){
            barcode = plus.barcode.create('barcode', [plus.barcode.QR], {
              top:'0px',
              left:'0px',
              width: '100%',
              height: '100%',
              position: 'static'
            });
            barcode.onmarked = onmarked;
            plus.webview.currentWebview().append(barcode);
          }
          barcode.start();
          barcode.onmarked = function(type, code, file){
            // loaded code 
            // console.log(type);
            // console.log(code);
            // console.log(file)
            barcode.close(); // 关闭
            // barcode.cancel(); // 取消
            let result = code;
            if (result.split('?')[0] !== location.origin + '/#/goodsdetail') {
              toast('温馨提示：此二维码非商品二维码')
              return false
            } else if (!result.split('?')[1]) {
              toast('温馨提示：此二维码非商品二维码')
              return false
            } else if (that.getLinkParam('itemId', result.split('?')[1]) === ''){
              toast('温馨提示：此二维码非商品二维码')
              return false
            } else if (that.getLinkParam('conference', result.split('?')[1]) === '') {
              toast('温馨提示：此二维码非商品二维码')
              return false
            } else {
              location.href = result
            }
          }
        }
        createBarcode();
      } else {
        toast('请在微信或支付宝中使用此功能')
      }
      console.log('end...')
      that.scanOn = true
    },
    getLinkParam (name, href) {
      let hashStr = href
      let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      let r = decodeURI(hashStr).match(reg)||'';
      if(r!='')return r[2]||''; return '';
    },
    testBtn () {
      console.log(window.location.href)
      alert(window.location.href)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue